import {expressCheckoutWidgetLoaded} from '@wix/bi-logger-events-data/v2'
import {PaymentMethod} from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod'
import {CashierExpressCheckoutWidget} from '@wix/cashier-express-checkout-widget'
import {EVENTS_APP_ID} from '@wix/wix-events-commons-statics'
import {useBi} from '@wix/yoshi-flow-editor'
import React, {useEffect, useState} from 'react'
import type {expressCheckout} from '../../../../actions/placed-order'
import {confirmPaymentSuccessStatuses} from '../../../../constants'
import {usePageStateSelector} from '../../../../hooks/state'
import {getEvent} from '../../../../selectors/event'
import {getDataFromInvoice} from './calculations'

interface Props {
  instanceId: string
  msid: string
  visitorId: string
  siteOwnerId: string
  instance: string
  locale: string
  expressCheckout: typeof expressCheckout
}

export const ExpressCheckout = ({
  instanceId,
  msid,
  visitorId,
  siteOwnerId,
  instance,
  locale,
  expressCheckout,
}: Props) => {
  const invoice = usePageStateSelector(state => state.placedOrder.order.invoice)
  const {clientStatus} = usePageStateSelector(state => state.placedOrder)
  const eventTitle = usePageStateSelector(state => getEvent(state).title)
  const {paymentAmount, paymentBreakdown, orderItems, currency} = getDataFromInvoice(invoice)
  const bi = useBi()
  const [resolve, setResolve] = useState(null)
  const [buttonsVisible, setButtonsVisible] = useState(false)
  const [onPaymentAuthorizedPromise, setOnPaymentAuthorizedPromise] = useState(null)

  useEffect(() => {
    setOnPaymentAuthorizedPromise(
      new Promise<{result: 'success' | 'error'}>(r => {
        setResolve(() => r)
      }),
    )
  }, [])

  useEffect(() => {
    if (onPaymentAuthorizedPromise && clientStatus) {
      resolve({result: confirmPaymentSuccessStatuses.includes(clientStatus) ? 'success' : 'error'})
      setOnPaymentAuthorizedPromise(
        new Promise<{result: 'success' | 'error'}>(r => {
          setResolve(() => r)
        }),
      )
    }
  }, [clientStatus])

  return (
    <div style={buttonsVisible ? {marginBottom: '20px'} : null}>
      <CashierExpressCheckoutWidget
        meta={{
          appDefId: EVENTS_APP_ID,
          appInstanceId: instanceId,
          siteId: msid,
          visitorId,
          siteOwnerId,
          appInstance: instance,
        }}
        allowPaymentMethods={[PaymentMethod.ApplePay, PaymentMethod.GooglePay]}
        layout="horizontal"
        buttonStyle={{shape: 'rect', height: 40}}
        requestShipping={false}
        onPaymentMethodsAmountInit={(buttonCount = 0) => {
          setButtonsVisible(Boolean(buttonCount))
          bi.report(expressCheckoutWidgetLoaded({visible_express_checkout_buttons: buttonCount.toString()}))
        }}
        locale={locale}
        currency={currency}
        domain={window.location.hostname}
        paymentAmount={paymentAmount}
        paymentLabel={eventTitle}
        paymentBreakdown={paymentBreakdown}
        orderItems={orderItems}
        onClick={async () => ({canceled: false})}
        onPaymentAuthorized={async params => {
          expressCheckout({paymentDetailsId: params.detailsId})
          return onPaymentAuthorizedPromise
        }}
      />
    </div>
  )
}
